'use client';

import { useRef } from 'react';
import HeroSection from './HeroSection';
import CapabilitiesOverview from './CapabilitiesOverview';
import InteractiveFiberLaser from './InteractiveFiberLaser';
import InteractiveCNCPunching from './InteractiveCNCPunching';
import InteractivePressBreak from './InteractivePressBreak';
import MaterialCompatibility from './MaterialCompatibility';
import ProcessShowcase from './ProcessShowcase';
import ProjectGallery from './ProjectGallery';
import NextStepCTA from './NextStepCTA';

export default function FabricationInteractive() {
  const exploreRef = useRef<HTMLDivElement>(null);

  const handleExploreClick = () => {
    exploreRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <HeroSection onExploreClick={handleExploreClick} />
      <CapabilitiesOverview />
      <div ref={exploreRef}>
        <InteractiveFiberLaser />
      </div>
      <InteractiveCNCPunching />
      <InteractivePressBreak />
      <MaterialCompatibility />
      <ProcessShowcase />
      <ProjectGallery />
      <NextStepCTA />
    </>
  );
}